import styled from "styled-components";

const Layout = styled.div`
  width: 100%;
  margin: 10px 0px;
  justify-content: space-between;
  @media (max-width: 600px){
    padding: 0px;
  }
  
  .documentContainer {
      margin: 40px 0;
    .documentModuleContainer {
        .documentsHeader {
            color: rgb(1, 105, 178);
            border-bottom: 3px solid rgb(1, 105, 178);
            font-family: Rubik-Medium;
            padding: 15px 10px;
            width: fit-content;
            margin-bottom: 15px;
            margin-right: 25px;
        }
        .documentSubContainer {
            @media (max-width: 600px){
               flex-wrap: wrap;
               justify-content: center;
            }
            display: flex;
            .documentContainerHolder {
                @media (max-width: 600px){
                       margin-bottom: 30px;
                }
                .downloadButtonContainer {
                    display: flex;
                    justify-content: center;
                    .downloadButton {
                        width: 150px;
                        text-align: center;
                        padding: 10px 20px;
                        border: 1px solid rgb(49, 113, 180);
                        border-radius: 20px;
                        background: rgb(49, 113, 180);
                        color: white;
                        cursor: pointer;
                        text-transform: uppercase;
                        font-weight: bold;
                    }
                }
                display: flex;
                flex-direction: column;
                .documentMainContainer {
                    cursor: pointer;
                    @media (max-width: 600px){
                       margin-right: 0;
                       margin-bottom: 20px;
                    }
                    width: 300px;
                    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 21px;
                    background-color: rgb(255, 255, 255);
                    position: relative;
                    margin-right: 10px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 20px 0;
                    margin-bottom: 20px;
                    .documentImage {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        padding: 10px 0;
                    img {
                        width: 100%
                        max-width: 250px
                    }
                }
                
                
            }
            
            .documentText {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                height: 100%;
                .titleText       {
                    font-size: 14px;
                    color: black;
                    font-weight: bold;
                }
                
                .titleLink {
                    margin-top: 10px;
                    color: rgb(49, 113, 180);
                    font-size: 14px;
                    font-weight: bold;
                    cursor: pointer;
                    i {
                        margin-left: 5px;
                    }
                }
            }
            }
        }
    }
  }
`;

const RewardTablesContainer = styled.div`
  width: 100%;
    .no-progress {
      text-align: center;
      background: white;
      height: 250px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }
  @media (max-width: 600px) {
    overflow: hidden;
    overflow-x: scroll;  
    white-space: nowrap;
  }
  @media (max-width: 330px) {
    height: 220px;
  }
  .padding {  
    padding: 15px;
  }
  .tableBody {
    @media (max-width: 600px) {
          width: 100em;
    }
    background-color: #ffffff;
    margin-bottom: 20px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 21px;
    .tableHeader {
        font-family: 'Rubik-Bold';
        font-size: 15px;
        align-items: center;
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
        background: #3171B4;
        color: white;
        font-weight: bold;
        text-transform: uppercase;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        height: 50px;
        .headerLeft {
            .tableHeaderIcon {
                margin-right: 20px;
                img {
                    width: 25px;
                }
            }
        }
    }
    .tableContentContainer {
        font-size: 16px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        background: red;
        .tableColumnHeader {
            display: flex;
            justify-content: space-between;
            .tableColumn {
                font-family: 'Rubik-Bold';
                font-size: 13px;
                display: flex;
                flex-basis: 18%;
                color: black;
                font-weight: bold;
                margin-bottom: 15px;
                &.flex-basis-30 {
                  flex-basis: 30% !important;
                }
            }
            .tableIcon {
                flex-basis: 10%;
                display: flex;
                justify-content: center;
                cursor: pointer;
                .fa.fa-check-circle {
                    color: green;
                    font-size: 20px;
                }
                .fa.fa-times {
                    color: red;
                    font-size: 20px;
                }
            }
        }
        .tableRowContainer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .tableRow {
                font-family: 'Rubik-Regular';
                font-size: 16px;
                color: rgb(153, 153, 153);
               display: flex;
               flex-basis: 18%;
               &:nth-child(3) {
                    font-weight: bold;
                    color: rgb(49, 113, 180);
               }
               &.flex-basis-30 {
                  flex-basis: 30% !important;
                }
            }
            .tableIcon {
                flex-basis: 10%;
                display: flex;
                justify-content: center;
                cursor: pointer;
                .fa.fa-check-circle {
                    color: green;
                    font-size: 20px;
                }
                .fa.fa-times {
                    color: red;
                    font-size: 20px;
                }
            }
        }
    }
  }
`;

const NoData = styled.div`
width: 100%;
display: flex;
font-family: Lato;
font-size: 18px;
line-height: 20px;
text-align: center;
color: #184A61;
justify-content: center;
`;


export {Layout, RewardTablesContainer, NoData};
